<!-- =========================================================================================
  File Name: timeLhc.vue
  Description: Lottery Time LHC
========================================================================================== -->

<template>
  <div id="lottery-time-lhc">

    <vx-card title="时间设置 (六合彩)">
      <div slot="actions">
        <vx-input-group>
          <vs-input class="w-48" v-model="number" placeholder="输入期号" />
          <template slot="append">
            <div class="append-text bg-warning cursor-pointer" @click="search">
              <feather-icon icon="SearchIcon"></feather-icon>
            </div>
          </template>
        </vx-input-group>
      </div>
      <vs-table stripe :data="list" noDataText="暂无开奖时间">
        <template slot="thead">
          <vs-th width="250">期号</vs-th>
          <vs-th width="400">开盘时间</vs-th>
          <vs-th width="400">封盘时间</vs-th>
          <vs-th width="400">开奖时间</vs-th>
          <vs-th width="300">操作</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="index" v-for="(item, index) in list" >
            <vs-td :data="item.number">
              <vs-input v-model="item.number" class="w-full" />
            </vs-td>
            <vs-td :data="item.start">
              <flat-pickr v-model="item.startDate" :config="flatPickrConfig" class="flatpickr-input w-full"></flat-pickr>
            </vs-td>
            <vs-td :data="item.feng">
              <flat-pickr v-model="item.fengDate" :config="flatPickrConfig" class="flatpickr-input w-full"></flat-pickr>
            </vs-td>
            <vs-td :data="item.kaijiang">
              <flat-pickr v-model="item.kaijiangDate" :config="flatPickrConfig" class="flatpickr-input w-full"></flat-pickr>
            </vs-td>
            <vs-td>
              <vs-button color="primary" type="filled" size="small" @click="modify" :data-index="index">{{item.id === -1 ? '添加' : '更改'}}</vs-button>
              <vs-button color="danger" type="filled" size="small" @click="del" :data-index="index" class="ml-2">删除</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <vs-divider></vs-divider>
      <vs-button color="success" type="filled" size="small" @click="add">添加新开奖时间</vs-button>
      <vs-divider></vs-divider>

      <vs-pagination class="mt-6" :total="totalPage" v-model="page" goto />
    </vx-card>

  </div>
</template>

<script>

import { Mandarin as flatPickrZh } from 'flatpickr/dist/l10n/zh.js'

export default {
  data() {
    return {
      flatPickrConfig: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i',
        locale: flatPickrZh
      },
      page: 1,
      totalPage: 1,
      list: [],
      number: ''
    }
  },
  watch: {
    page(newValue) {
      this.page = newValue
      this.load()
    }
  },
  methods: {
    modify (e) {
      const dataset = e.currentTarget.dataset
      const postdata = this.list[dataset.index]
      postdata.authKey = localStorage.getItem('authKey')
      this.$utils.post('lottery-timeLhcDo', postdata).then(res => {
        this.$vs.dialog({
          title: '提示',
          text: res,
          acceptText: '确认'
        })
        this.load()
      })
    },
    load () {
      const postdata = {}
      postdata.authKey = localStorage.getItem('authKey')
      postdata.page = this.page
      postdata.number = this.number
      this.$utils.post('lottery-timeLhcList', postdata).then(res => {
        this.list = res.list
        this.totalPage = Math.ceil(res.count / res.pagesize)
      })
    },
    search() {
      this.page = 1
      this.load()
    },
    add() {
      this.list.push({ id: -1 })
    },
    del(e) {
      const index = e.currentTarget.dataset.index
      if (this.list[index].id === -1) {
        this.list.splice(index, 1)
      } else {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: '确认',
          text: '确认删除本条开奖信息吗?',
          acceptText: '确认',
          cancelText: '取消',
          accept: () => {
            const postdata = {}
            postdata.authKey = localStorage.getItem('authKey')
            postdata.id = this.list[index].id
            this.$utils.post('lottery-timeLhcDelete', postdata).then(res => {
              this.$vs.dialog({
                title: '提示',
                text: res,
                acceptText: '确认'
              })
              this.load()
            })
          }
        })
      }
    }
  },
  mounted () {
    this.load()
  }
}
</script>
